import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { Icon } from '../index';
import Button from '../button/button';
import ReactDOM from 'react-dom';
import { tuple } from '../_utils/type';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import Draggable from 'react-draggable';
import { getLangMsg } from '../locale/locale';
import { useHideDocumentScrollBar } from '../_utils/hooks';
export var ConfirmModalTypes = ['confirm', 'normal'];
export var ModalTypes = tuple('confirm', 'warning', 'error', 'normal');
var DragDirection;
(function (DragDirection) {
  DragDirection["N"] = "n";
  DragDirection["E"] = "e";
  DragDirection["S"] = "s";
  DragDirection["W"] = "w";
  DragDirection["NE"] = "ne";
  DragDirection["NW"] = "nw";
  DragDirection["SE"] = "se";
  DragDirection["SW"] = "sw";
})(DragDirection || (DragDirection = {}));
var initPosition = {
  initialX: 0,
  initialY: 0,
  initialWidth: 0,
  initialHeight: 0,
  top: 0,
  left: 0,
  x: 0,
  y: 0,
  type: null
};
var InternalModal = function InternalModal(props, ref) {
  var _classNames3, _classNames4, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var modalProps = getCompProps('Modal', userDefaultProps, props); // 属性需要合并一遍用户定义的默认属性
  var body = modalProps.body,
    bodyClassName = modalProps.bodyClassName,
    bodyStyle = modalProps.bodyStyle,
    cancelButtonProps = modalProps.cancelButtonProps,
    cancelText = modalProps.cancelText,
    className = modalProps.className,
    closable = modalProps.closable,
    closeIcon = modalProps.closeIcon,
    destroyOnClose = modalProps.destroyOnClose,
    draggable = modalProps.draggable,
    focusTriggerAfterClose = modalProps.focusTriggerAfterClose,
    footer = modalProps.footer,
    footerClassName = modalProps.footerClassName,
    footerStyle = modalProps.footerStyle,
    footerBtnOrder = modalProps.footerBtnOrder,
    getContainer = modalProps.getContainer,
    height = modalProps.height,
    keyboard = modalProps.keyboard,
    mask = modalProps.mask,
    maskClosable = modalProps.maskClosable,
    maskStyle = modalProps.maskStyle,
    maskClassName = modalProps.maskClassName,
    okButtonProps = modalProps.okButtonProps,
    okText = modalProps.okText,
    onCancel = modalProps.onCancel,
    onOk = modalProps.onOk,
    customPrefixcls = modalProps.prefixCls,
    title = modalProps.title,
    titleIcon = modalProps.titleIcon,
    type = modalProps.type,
    visible = modalProps.visible,
    width = modalProps.width,
    showline = modalProps.showline,
    onDragStart = modalProps.onDragStart,
    onDrag = modalProps.onDrag,
    onDragStop = modalProps.onDragStop,
    bounds = modalProps.bounds,
    overroll = modalProps.overroll,
    resizable = modalProps.resizable,
    others = __rest(modalProps, ["body", "bodyClassName", "bodyStyle", "cancelButtonProps", "cancelText", "className", "closable", "closeIcon", "destroyOnClose", "draggable", "focusTriggerAfterClose", "footer", "footerClassName", "footerStyle", "footerBtnOrder", "getContainer", "height", "keyboard", "mask", "maskClosable", "maskStyle", "maskClassName", "okButtonProps", "okText", "onCancel", "onOk", "prefixCls", "title", "titleIcon", "type", "visible", "width", "showline", "onDragStart", "onDrag", "onDragStop", "bounds", "overroll", "resizable"]);
  var isForceController = visible !== undefined;
  var _useState = useState(isForceController ? visible : true),
    _useState2 = _slicedToArray(_useState, 2),
    innerVisible = _useState2[0],
    setInnerVisible = _useState2[1]; // 需要根据visible来判断，不能一开始为true再去设置false
  var previousActiveElement = useRef(null);
  var innerRef = useRef(null);
  var wrapperRef = useRef(null);
  var containerRef = ref || innerRef;
  var modalPrefixCls = getPrefixCls(prefixCls, 'modal', customPrefixcls);
  devWarning(ModalTypes.indexOf(type) === -1, 'modal', "cannot found modal type '".concat(type, "'"));
  var modalContainer = typeof getContainer === 'function' ? getContainer() : getContainer;
  if (modalContainer !== false && !(modalContainer instanceof HTMLElement)) {
    try {
      modalContainer = document.querySelector(modalContainer);
    } catch (error) {
      devWarning(true, 'modal', 'getContainer"s returnValue/value is not a correct CSSSelector');
    }
    modalContainer = document.body;
  }
  var _useState3 = useState(modalContainer && !overroll ? {
      x: -(width / 2),
      y: -(height / 2)
    } : {
      x: 0,
      y: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    position = _useState4[0],
    setPosition = _useState4[1];
  useHideDocumentScrollBar(isForceController ? !!visible : !!innerVisible, modalContainer === document.body, !!mask);
  var closeModal = useCallback(function () {
    setInnerVisible(false);
  }, []);
  var proxyCloseModal = useCallback(function (onDoingAction, event) {
    onDoingAction && onDoingAction(event);
    if (isForceController) {
      return;
    }
    closeModal();
  }, [isForceController, closeModal]);
  var escapeToCloseModal = useCallback(function (evt) {
    var _context;
    // In Internet Explorer 9 and Firefox 36 and earlier, the Esc key returns "Esc" instead of "Escape"
    if (_includesInstanceProperty(_context = ['Escape', 'Esc']).call(_context, evt.key)) {
      proxyCloseModal(onCancel);
    }
  }, [proxyCloseModal, onCancel]);
  var enterToCloseModal = useCallback(function (evt) {
    if (evt.key === 'Enter' && evt.target === containerRef.current) {
      proxyCloseModal(onOk);
      // 无效
      // evt.stopPropagation()
    }
  }, [proxyCloseModal, onOk]);
  var isConfirmType = _includesInstanceProperty(ConfirmModalTypes).call(ConfirmModalTypes, type);
  var isNormalBtn = !footerBtnOrder || footerBtnOrder === 'normal';
  var finalCancelButtonProps = _extends({
    onClick: useCallback(function (event) {
      proxyCloseModal(onCancel, event);
    }, [onCancel, proxyCloseModal]),
    type: 'second',
    className: classNames("".concat(modalPrefixCls, "-cancel-btn"), _defineProperty({}, "".concat(modalPrefixCls, "-margin-btn"), isConfirmType && isNormalBtn))
  }, cancelButtonProps);
  var finalOkButtonProps = _extends({
    onClick: useCallback(function (event) {
      proxyCloseModal(onOk, event);
    }, [onOk, proxyCloseModal]),
    type: _includesInstanceProperty(ConfirmModalTypes).call(ConfirmModalTypes, type) ? 'primary' : 'second',
    className: classNames("".concat(modalPrefixCls, "-ok-btn"), _defineProperty({}, "".concat(modalPrefixCls, "-margin-btn"), isConfirmType && !isNormalBtn))
  }, okButtonProps);
  var generatorFooterByType = useCallback(function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'confirm';
    switch (type) {
      case 'error':
      case 'warning':
        {
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(modalPrefixCls, "-iknow-node")
          }, /*#__PURE__*/React.createElement(Button, _extends({}, finalOkButtonProps), okText || getLangMsg('Modal', 'iknowText')));
        }
      case 'confirm':
      case 'normal':
      default:
        {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "".concat(modalPrefixCls, "-cancel-node")
          }, /*#__PURE__*/React.createElement(Button, _extends({}, finalCancelButtonProps), cancelText || getLangMsg('Modal', 'cancelText'))), /*#__PURE__*/React.createElement("div", {
            className: "".concat(modalPrefixCls, "-ok-node")
          }, /*#__PURE__*/React.createElement(Button, _extends({}, finalOkButtonProps), okText || getLangMsg('Modal', 'okText'))));
        }
    }
  }, [modalPrefixCls, okText, cancelText, finalCancelButtonProps, finalOkButtonProps]);
  useEffect(function () {
    if (isForceController) {
      // 强控制下只有下面该条件成立获取焦点
      if (focusTriggerAfterClose && visible === true) {
        !previousActiveElement.current && (previousActiveElement.current = document.activeElement);
      }
    } else {
      // 不控制时, 只有下面该条件成立获取焦点
      focusTriggerAfterClose && !previousActiveElement.current && (previousActiveElement.current = document.activeElement);
    }
    return function () {
      if (focusTriggerAfterClose && previousActiveElement.current) {
        // 这里可能有种情况，如果回车触发弹窗，由于回车又可以关闭弹窗，会导致连续触发回车
        ;
        previousActiveElement.current.focus();
        previousActiveElement.current = null;
      }
    };
  }, [focusTriggerAfterClose, visible, isForceController]);
  useEffect(function () {
    if (keyboard) {
      document.body.addEventListener('keydown', escapeToCloseModal);
    }
    return function () {
      document.body.removeEventListener('keydown', escapeToCloseModal);
    };
  }, [keyboard, escapeToCloseModal, proxyCloseModal, onCancel]);
  var isResizing = false;
  var initPositionRef = useRef(initPosition);
  var startResize = useCallback(function (event) {
    var targetElement = event.target;
    if (!targetElement.classList.contains("".concat(modalPrefixCls, "-resise-handle")) || !containerRef.current) {
      return;
    }
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      initialWidth = _containerRef$current.width,
      initialHeight = _containerRef$current.height,
      top = _containerRef$current.top,
      left = _containerRef$current.left;
    initPositionRef.current = {
      initialX: event.clientX,
      initialY: event.clientY,
      initialWidth: initialWidth,
      initialHeight: initialHeight,
      top: top,
      left: left,
      x: position.x,
      y: position.y,
      type: targetElement.dataset.type
    };
    event.preventDefault();
    isResizing = true;
    if (overroll && wrapperRef.current) {
      wrapperRef.current.classList.add("".concat(modalPrefixCls, "-wrapper-resizable"));
      setPosition({
        x: left,
        y: top
      });
      initPositionRef.current.x = left;
      initPositionRef.current.y = top;
    }
    document.addEventListener('mousemove', resize);
    document.addEventListener('mouseup', stopResize);
  }, [position]);
  useEffect(function () {
    if (containerRef.current && visible) {
      containerRef.current.addEventListener('mousedown', startResize);
    }
    return function () {
      if (containerRef.current) {
        containerRef.current.removeEventListener('mousedown', startResize);
      }
    };
  }, [containerRef, startResize, visible]);
  var resize = function resize(event) {
    if (!containerRef.current) return;
    if (!isResizing || !containerRef.current) return;
    var _initPositionRef$curr = initPositionRef.current,
      initialX = _initPositionRef$curr.initialX,
      initialY = _initPositionRef$curr.initialY,
      initialHeight = _initPositionRef$curr.initialHeight,
      initialWidth = _initPositionRef$curr.initialWidth,
      y = _initPositionRef$curr.y,
      x = _initPositionRef$curr.x,
      type = _initPositionRef$curr.type;
    var curNHeight = initialY - event.clientY;
    var curSHeight = -curNHeight;
    var curEWidth = event.clientX - initialX;
    var curWWidth = -curEWidth;
    switch (type) {
      case DragDirection.N:
        {
          containerRef.current.style.height = "".concat(curNHeight + initialHeight, "px");
          setPosition(function (pre) {
            return {
              y: y - curNHeight,
              x: pre.x
            };
          });
          break;
        }
      case DragDirection.E:
        {
          containerRef.current.style.width = "".concat(curEWidth + initialWidth, "px");
          break;
        }
      case DragDirection.S:
        {
          containerRef.current.style.height = "".concat(curSHeight + initialHeight, "px");
          break;
        }
      case DragDirection.W:
        {
          containerRef.current.style.width = "".concat(curWWidth + initialWidth, "px");
          setPosition(function (pre) {
            return {
              y: pre.y,
              x: x - curWWidth
            };
          });
          break;
        }
      case DragDirection.NE:
        {
          containerRef.current.style.height = "".concat(curNHeight + initialHeight, "px");
          containerRef.current.style.width = "".concat(curEWidth + initialWidth, "px");
          setPosition(function (pre) {
            return {
              y: y - curNHeight,
              x: pre.x
            };
          });
          break;
        }
      case DragDirection.NW:
        {
          containerRef.current.style.height = "".concat(curNHeight + initialHeight, "px");
          containerRef.current.style.width = "".concat(curWWidth + initialWidth, "px");
          setPosition({
            y: y - curNHeight,
            x: x - curWWidth
          });
          break;
        }
      case DragDirection.SE:
        {
          containerRef.current.style.height = "".concat(curSHeight + initialHeight, "px");
          containerRef.current.style.width = "".concat(curEWidth + initialWidth, "px");
          break;
        }
      case DragDirection.SW:
        {
          containerRef.current.style.width = "".concat(curWWidth + initialWidth, "px");
          containerRef.current.style.height = "".concat(curSHeight + initialHeight, "px");
          setPosition(function (pre) {
            return {
              y: pre.y,
              x: x - curWWidth
            };
          });
          break;
        }
      default:
        {
          break;
        }
    }
  };
  var stopResize = function stopResize() {
    isResizing = false;
    initPositionRef.current = initPosition;
    document.removeEventListener('mousemove', resize);
    document.removeEventListener('mouseup', stopResize);
  };
  var handleMaskClick = useCallback(function () {
    if (maskClosable) {
      proxyCloseModal(onCancel);
    }
  }, [proxyCloseModal, onCancel, maskClosable]);
  var handleWrapperClick = function handleWrapperClick(e) {
    if (wrapperRef.current === e.target) {
      handleMaskClick();
    }
  };
  var isHidden = !destroyOnClose && !(isForceController ? visible : innerVisible);
  var modalClasses = classNames(modalPrefixCls, className, (_classNames3 = {}, _defineProperty(_classNames3, "".concat(modalPrefixCls, "-container"), true), _defineProperty(_classNames3, "".concat(modalPrefixCls, "-container-hidden"), isHidden), _defineProperty(_classNames3, "".concat(modalPrefixCls, "-container-show"), !isHidden), _classNames3));
  var headerClass = "".concat(modalPrefixCls, "-header");
  var container = /*#__PURE__*/React.createElement("div", {
    className: classNames((_classNames4 = {}, _defineProperty(_classNames4, "".concat(modalPrefixCls, "-container-box"), true), _defineProperty(_classNames4, "".concat(modalPrefixCls, "-has-container-box"), modalContainer && !overroll), _defineProperty(_classNames4, "".concat(modalPrefixCls, "-showline"), showline), _classNames4)),
    style: {
      width: width,
      height: height
    },
    ref: containerRef,
    tabIndex: -1,
    onKeyDown: enterToCloseModal
  }, resizable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-type": "n",
    className: _concatInstanceProperty(_context2 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context2, modalPrefixCls, "-resise-n")
  }), /*#__PURE__*/React.createElement("div", {
    "data-type": "e",
    className: _concatInstanceProperty(_context3 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context3, modalPrefixCls, "-resise-e")
  }), /*#__PURE__*/React.createElement("div", {
    "data-type": "s",
    className: _concatInstanceProperty(_context4 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context4, modalPrefixCls, "-resise-s")
  }), /*#__PURE__*/React.createElement("div", {
    "data-type": "w",
    className: _concatInstanceProperty(_context5 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context5, modalPrefixCls, "-resise-w")
  }), /*#__PURE__*/React.createElement("div", {
    "data-type": "ne",
    className: _concatInstanceProperty(_context6 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context6, modalPrefixCls, "-resise-ne")
  }), /*#__PURE__*/React.createElement("div", {
    "data-type": "se",
    className: _concatInstanceProperty(_context7 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context7, modalPrefixCls, "-resise-se")
  }), /*#__PURE__*/React.createElement("div", {
    "data-type": "sw",
    className: _concatInstanceProperty(_context8 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context8, modalPrefixCls, "-resise-sw")
  }), /*#__PURE__*/React.createElement("div", {
    "data-type": "nw",
    className: _concatInstanceProperty(_context9 = "".concat(modalPrefixCls, "-resise-handle ")).call(_context9, modalPrefixCls, "-resise-nw")
  })), /*#__PURE__*/React.createElement("div", {
    className: headerClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(modalPrefixCls, "-title-container")
  }, titleIcon !== undefined ? titleIcon : type !== 'normal' && /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(modalPrefixCls, "-title-icon"), _defineProperty({}, "modal-".concat(type, "-title-icon-bgcolor"), type))
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(modalPrefixCls, "-title")
  }, title)), closable && /*#__PURE__*/React.createElement("div", {
    className: "".concat(modalPrefixCls, "-close-icon"),
    onClick: function onClick() {
      return proxyCloseModal(onCancel);
    }
  }, closeIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(modalPrefixCls, "-body"), bodyClassName),
    style: bodyStyle
  }, body), footer !== null && /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(modalPrefixCls, "-footer"), _concatInstanceProperty(_context10 = "".concat(modalPrefixCls, "-")).call(_context10, type, "-footer"), footerClassName),
    style: _extends({
      flexDirection: !footer && (!footerBtnOrder || footerBtnOrder === 'normal') ? 'row' : 'row-reverse'
    }, footerStyle || {})
  }, footer || generatorFooterByType(type)));
  // 没有容器应该是不用居中的
  // 但仍可拖拽
  var handleDragStart = function handleDragStart(e, data) {
    onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(e, data);
  };
  var handleDrag = function handleDrag(e, ui) {
    setPosition({
      x: ui.x,
      y: ui.y
    });
    onDrag === null || onDrag === void 0 ? void 0 : onDrag(e, ui);
  };
  var comp = /*#__PURE__*/React.createElement("div", _extends({
    className: modalClasses
  }, others), mask && /*#__PURE__*/React.createElement("div", {
    onClick: handleMaskClick,
    className: classNames(maskClassName, _defineProperty({}, "".concat(modalPrefixCls, "-mask"), true)),
    style: maskStyle
  }), overroll ? /*#__PURE__*/React.createElement("div", {
    tabIndex: -1,
    className: classNames(_defineProperty({}, "".concat(modalPrefixCls, "-wrapper"), modalContainer && ((isForceController ? visible : innerVisible) || !destroyOnClose))),
    ref: wrapperRef,
    onMouseDown: handleWrapperClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(modalPrefixCls, "-dialog")
  }, /*#__PURE__*/React.createElement(Draggable, {
    position: position,
    handle: ".".concat(headerClass),
    disabled: !draggable,
    onStart: handleDragStart,
    onDrag: handleDrag,
    onStop: onDragStop,
    bounds: bounds,
    cancel: _concatInstanceProperty(_context11 = ".".concat(modalPrefixCls, "-title-container, .")).call(_context11, modalPrefixCls, "-close-icon")
  }, container))) : /*#__PURE__*/React.createElement(Draggable, {
    handle: ".".concat(headerClass),
    disabled: !draggable,
    position: position,
    onStart: handleDragStart,
    onDrag: handleDrag,
    onStop: onDragStop,
    bounds: bounds,
    cancel: _concatInstanceProperty(_context12 = ".".concat(modalPrefixCls, "-title-container, .")).call(_context12, modalPrefixCls, "-close-icon")
  }, container));
  var renderComp = ((isForceController ? visible : innerVisible) || !destroyOnClose) && comp;
  if (modalContainer && renderComp) return /*#__PURE__*/ReactDOM.createPortal(renderComp, modalContainer);
  return renderComp || null;
};
var Modal = /*#__PURE__*/React.forwardRef(InternalModal);
Modal.displayName = 'Modal';
export default Modal;